import { FaPiggyBank } from "react-icons/fa";
import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Offer Description Row",
  name: "offerDescriptionRow",
  type: "object",
  icon: FaPiggyBank,
  fields: [
    {
      name: "heading",
      title: "Heading",
      type: "sectionTitle"
    },
    {
      name: "offers",
      title: "Offers",
      type: "array",
      of: [
        {
          type: "reference",
          to: [{ type: "exclusiveOfferPerPromo" }]
        }
      ]
    },
    {
      name: "description",
      title: "Description",
      type: "multilingualArrayBlockContent"
    },
    {
      name: "termsAndConditions",
      title: "Terms and conditions",
      type: "multilingualArrayBlockContent"
    }
  ],
  preview: {
    select: {
      title: "heading.title"
    },
    prepare({ title }) {
      return {
        title: multilingualStringPreview(title) || "(Offer description row)"
      };
    }
  }
});
